<template>
	<div>
		<div style="padding: 0 220px 50px;">
			<div class="nodea" v-if="count.length == 0"><img src="../../../assets/img/nodata.png" /></div>
			<div class="list_box" v-for="(item, index) in count" :key="index" infinite-scroll-disabled="disabled">
				<div class="two-overflow type_size_22">{{ item.name }}</div>
				<div class="p_flex p_f_a p_f_b p_m_t_20">
					<div class="p_flex type_size_16">
						<div v-for="(ietm, index) in item.question_type" :key="index">
							<span class="subject_color">{{ ietm }}</span>
							<el-divider direction="vertical" v-if="item.question_type.slice(-1)[0] == ietm ? false : true"></el-divider>
						</div>
					</div>
				</div>
				<div class="p_flex p_f_a p_f_b p_m_t_20">
					<div class="p_flex type_size_16">
						<span class="subject_color">{{ item.grade_def }}</span>
						<el-divider direction="vertical"></el-divider>
						<span class="subject_yellow">{{ item.subject_def }}</span>
						<el-divider direction="vertical"></el-divider>
						<span>{{ item.question_count }}道题</span>
						<el-divider direction="vertical"></el-divider>
						<span>{{ item.score }}分</span>
					</div>
					<div class="p_flex">
						<el-button @click="godelete(item.id)" type="info" plain size="mini">删除</el-button>
						<el-button type="info" plain size="mini" @click="xiugai(item.id)">修改名称</el-button>
						<!-- <el-button type="info" plain size="mini" @click="xg(item)">修改</el-button>
						<el-button type="info" plain size="mini" @click="xzs(item.id)">下载</el-button> -->
						<el-button type="info" plain size="mini" v-show="id == 1 ? false : true" @click="scs(item.id)">上传校本题库</el-button>
						<el-button @click="goIssue(item)" class="heaer_btn" size="mini" type="warning">下发</el-button>
					</div>
				</div>
			</div>
		</div>
		<el-dialog title="提示" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
			<el-input type="text" :rows="2" placeholder="请输入名称" v-model="dialogVisibleanswerVal"></el-input>
			<span slot="footer" class="dialog-footer"><el-button type="primary" @click="caoafor">确 定</el-button></span>
		</el-dialog>
		<pagination @get="get" :index="num" />
	</div>
</template>

<script>
import pagination from '../../pagination/pagination.vue';
export default {
	props: {
		ages: Number,
		agess: Number
	},
	data() {
		return {
			count: [],
			loading: false,
			num: 0,
			names: 0,
			namess: 0,
			id: '',
			dialogVisible: false,
			dialogVisibleanswerVal: '',
			dialogID: ''
		};
	},
	components: {
		pagination
	},
	created() {
		this.id = this.$route.query.id;
		this.get();
	},
	mounted() {},
	watch: {
		ages: {
			handler(i, o) {
				// console.log(i)
				this.names = i;
				this.get();
			}
		},
		agess: {
			handler(i, o) {
				// console.log(i)
				this.namess = i;
				this.get();
			}
		}
	},
	methods: {
		xg(info) {
			//修改习题册
			this.$router.push({
				path: '/NewExercises',
				query: {
					info: JSON.stringify(info)
				}
			});
		},
		xiugai(id) {
			this.dialogVisible = true;
			this.dialogID = id;
		},
		caoafor() {
			if (this.dialogVisibleanswerVal == '') {
				this.$message.error('请输入名称');
				return;
			}
			this.xiugaiInfo()
		},
		handleClose() {
			this.dialogVisibleanswerVal == '';
			this.dialogVisible = false;
		},
		xiugaiInfo(i, v) {
			this.$request
				.ajax(this)
				.post('/api_teacher/exercise_book_edit/' + this.dialogID, {
					name: this.dialogVisibleanswerVal
				})
				.then(res => {
					// console.log(res)
					this.dialogVisible = false;
					this.dialogVisibleanswerVal == '';
					this.get();
				});
		},
		scs(id) {
			//上传
			this.$request
				.ajax(this)
				.post('/api_teacher/exercise_book_push_school/' + id)
				.then(res => {
					// console.log(res)
				});
		},
		xzs(id) {
			this.$request
				.ajax(this)
				.post('/api_teacher/exercise_book_export/' + id)
				.then(res => {
					console.log(res);
					// res.data.file
					window.open(res.data.file);
				});
		},
		get(id) {
			// console.log(id)
			this.$request
				.ajax(this)
				.post('/api_teacher/exercise_book_list', {
					belonging: this.$route.query.id == 1 ? 1 : 2, //教师习库
					page: id ? id : 1, //第几页
					limit: 10, //，每页显示
					grade: this.names, //年纪
					subject: this.namess, //学科
					type: 2
				})
				.then(res => {
					// console.log(res)
					this.count = res.data.list;
					this.num = res.data.count;
				});
		},
		// 下发
		goIssue(id) {
			// console.log(id)
			const that = this;
			this.$emit('goIssue', true, id);
		},
		godelete(id) {
			this.$confirm('此操作将永久删除, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
					this.$request
						.ajax(this)
						.post('/api_teacher/exercise_book_delete/' + id)
						.then(res => {
							console.log(res);
							this.$message({
								type: 'success',
								message: '删除成功!'
							});
							this.get();
						});
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
		}
	}
};
</script>

<style lang="scss" scoped>
.list_box {
	padding: 20px 0;
	border-bottom: 1px solid #e6e6e6;
	margin: 0 20px;
}
>>> .el-divider {
	background-color: #999999;
}

>>> .el-button--primary {
	background-color: #00af63 !important;
	border-color: #00af63 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/homet/commponents/mineSheet.vue